import React from 'react'
import { array, object, func } from 'prop-types'

import { Button } from 'react-bootstrap'

import QueryEditor from 'coact/QueryEditor'

import style from './style'

function Filter (props) {
  const { query, setQuery, fields, schema, setting, download } = props
  return (
    <div>
      <h3 className={style.pageTitle} style={{ marginBottom: 10 }}>銷貨單報表下載</h3>
      <div>
        <QueryEditor
          {...{
            value: query,
            onChange: setQuery,
            fields,
            schema,
            setting,
          }}
        />
        <div>
          <Button bsStyle="primary" onClick={download}>下載</Button>
        </div>
      </div>
    </div>
  )
}
Filter.propTypes = {
  query: object.isRequired,
  setQuery: func.isRequired,
  fields: array.isRequired,
  schema: object.isRequired,
  setting: object.isRequired,

  download: func.isRequired,
}

module.exports = Filter



// WEBPACK FOOTER //
// ./src/components/SalesOrderReport/Filter.jsx